import { NOTIFICATIONS_MAX_BELL_ITEMS } from "../constants";
import { NotificationItem } from "../types";
import { extractNotificationsRowsFromApiData } from "./extractNotificationsRowsFromApiData";
import { mapApiNotificationRecordsToItems } from "./mapApiNotificationRecordsToItems";

type ParsedNotificationsListResponse = {
  items: NotificationItem[];
  currentPage: number;
  lastPage: number;
  total: number;
  perPage: number;
};

const resolveContainer = (response: unknown): Record<string, unknown> => {
  if (typeof response !== "object" || response === null) {
    return {};
  }

  const root = response as Record<string, unknown>;
  if (
    typeof root.current_page === "number" ||
    typeof root.last_page === "number" ||
    typeof root.total === "number"
  ) {
    return root;
  }

  if (typeof root.data === "object" && root.data !== null) {
    const dataLevel = root.data as Record<string, unknown>;
    if (
      typeof dataLevel.current_page === "number" ||
      typeof dataLevel.last_page === "number" ||
      typeof dataLevel.total === "number"
    ) {
      return dataLevel;
    }

    if (typeof dataLevel.data === "object" && dataLevel.data !== null) {
      const nested = dataLevel.data as Record<string, unknown>;
      if (
        typeof nested.current_page === "number" ||
        typeof nested.last_page === "number" ||
        typeof nested.total === "number"
      ) {
        return nested;
      }
    }
  }

  return root;
};

const getNumber = (
  value: unknown,
  fallback: number
): number => {
  return typeof value === "number" ? value : fallback;
};

export const parseCompanyNotificationsListResponse = (
  response: unknown
): ParsedNotificationsListResponse => {
  const rows = extractNotificationsRowsFromApiData(response);
  const items = mapApiNotificationRecordsToItems(rows);
  const container = resolveContainer(response);

  return {
    items,
    currentPage: getNumber(container.current_page, 1),
    lastPage: getNumber(container.last_page, 1),
    total: getNumber(container.total, items.length),
    perPage: Math.max(
      1,
      getNumber(container.per_page, NOTIFICATIONS_MAX_BELL_ITEMS)
    ),
  };
};
